import React from 'react';

interface RepeatBarProps {
  type: 'start' | 'end';
}

// RepeatBar with refined design - thinner bars, smaller dots, tighter spacing
const RepeatBar: React.FC<RepeatBarProps> = ({ type }) => {
  // Thick line: reduced to 2.2px  
  const thickLine = <div className="w-0.5 bg-gray-400 h-full" style={{ width: '2.2px' }} />;
  // Thin line: reduced to 1.2px
  const thinLine = <div className="bg-gray-400 h-full" style={{ width: '1.2px' }} />;
  const dots = (
    // Reduced padding to push dots closer to bars
    <div className="flex flex-col h-full justify-center items-center px-px">
      {/* Dots: reduced to 3.8px, closer spacing */}
      <div className="bg-gray-400 rounded-full mb-0.5" style={{ width: '3.8px', height: '3.8px' }} />
      <div className="bg-gray-400 rounded-full mt-0.5" style={{ width: '3.8px', height: '3.8px' }} />
    </div>
  );
  
  const content = type === 'start'
    ? <>{thickLine}{thinLine}{dots}</>
    : <>{dots}{thinLine}{thickLine}</>;
    
  return (
    // Small gap between elements to separate thick/thin lines, but tight overall spacing
    <div className="h-full flex items-stretch gap-0.5 min-w-[10px]">
      {content}
    </div>
  );
};

export default RepeatBar;
